
import Image404 from '../assets/images/404.svg'

export default function Page404() {
    return (
        <div
            className='w-100 text-center h-100 mt-5 p-3'
            style={{ margin: '5em 0' }}
        >
            <div className='col-12'>
                <img src={Image404} alt=""
                    width={300}
                />
            </div >
            <div className='col-12'><h1 className='text-dark'>Pagina no enontrada</h1></div>
            <a href="/" className='btn btn-primary w-100 my-4'>Volver al inicio</a>
        </div>
    )
}
